export default __webpack_public_path__ + "static/media/requestIcon.fdd89431.svg";